export default "__VITE_ASSET__$88i0fvl__";